import SynchronousBlocker from './SynchronousBlocker';
import SyncBlockerLoadingPlaceholder from './SynchronousBlockerLoadingPlaceholder';

export default SynchronousBlocker;
export { SynchronousBlocker, SyncBlockerLoadingPlaceholder };
